export default __webpack_public_path__ + "static/media/Horizo Barcode.e6c4296c.svg";